import React, { useState, useEffect } from 'react';
import {
	IconButton,
	TableCell,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Paper,
	Tooltip,
	Chip,
	Switch,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddModerator from '@mui/icons-material/AddModerator';
import Loader from '../../../components/Loader';
import authService from '../../../services/auth.service';

const BannerTable = ({
	data,
	handleEdit,
	handleDisable,
	setBannerDataPage,
	setBannerDataLimit,
	bannerDataPage,
	bannerDataLimit,
	handleAddPlan,
	handleToggle,
}) => {
	console.log(data)
	const [gridLoader, setGridLoader] = useState(false);
	const [canEdit, setCanEdit] = useState(true);
	const imageType = [{name:"Home Screen", key:"home_screen"}]
	useEffect(() => {
		setGridLoader(false);
		const user = authService.getCurrentUser();
		if (user?.permissions && user?.permissions === 'read-only') {
			setCanEdit(false);
		}
	}, [data?.data]);

	const handleChangePage = (event, newPage) => {
		setGridLoader(true);
		console.log(newPage)
		setBannerDataPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setGridLoader(true);
		setBannerDataPage(0);
		setBannerDataLimit(+event.target.value);
	};

	const getBannerType = (type) => {
		const bannerType = imageType.find((item) => item.key === type);
		return bannerType?.name || '';
	
	}

	return (
		<Paper sx={{ position: 'relative', overflowX: 'clip' }}>
			<>
				{(!data || gridLoader) && <Loader showLoader />}
				<TableContainer>
					<Table stickyHeader aria-label="sticky table">
						<TableHead>
							<TableRow>
								<TableCell align="left">Image</TableCell>
								<TableCell align="left">Title</TableCell>
								<TableCell align="left">Order</TableCell>
								<TableCell align="left">Type</TableCell>
								{canEdit && <TableCell align="left">Toggle</TableCell>}
								<TableCell align="center">Status</TableCell>
								{canEdit && <TableCell align="center">Action</TableCell>}
							</TableRow>
						</TableHead>
						<TableBody>
							{(!data || data?.data?.length == 0) && (
								<TableRow hover role="checkbox" >
									<TableCell colSpan={5} align="center"> No data found</TableCell>
								</TableRow>
							)} 
							{data?.data?.map((row) => (
								<TableRow hover role="checkbox" key={row?._id}>
									<TableCell align="left">
										<img
											src={`${row?.imageUrl}`}
											width="80px"
											style={{
												borderRadius: '5px',
												border: '1px solid lightgray',
												width: '60px',
												height: '60px',
												objectFit: 'cover',
											}}
										/>
									</TableCell>
									<TableCell align="left">{row?.title}</TableCell>
									{row?.status == 'ACTIVE' && <TableCell align="left"><strong>{row?.order || '--'}</strong></TableCell>}
									{row?.status != 'ACTIVE' && <TableCell align="left"> -- </TableCell>}
									<TableCell align="left"> {getBannerType(row.imageType)} </TableCell>
									{canEdit && (
										<TableCell align="left">
											<Switch
												checked={row?.status == 'ACTIVE'}
												onChange={(event) => handleToggle(event, row)}
												name="loading"
												color="primary"
												key={row?._id}
											/>
										</TableCell>
									)}
									<TableCell align="center">
										<Chip
											label={row?.status == 'ACTIVE' ? 'Enabled' : 'Disabled'}
											size="small"
											color={row?.status == 'ACTIVE' ? 'success' : 'primary'}
										/>
									</TableCell>
									{canEdit && (
										<TableCell align="center">
											{/* <Tooltip title='Add Insurance Plan'>
                          <IconButton size='small' onClick={(event) => handleAddPlan(event, row)}>
                            <AddModerator fontSize='small' />
                          </IconButton>
                        </Tooltip> */}
											<Tooltip title="Edit">
												<IconButton size="small" onClick={(event) => handleEdit(event, row)}>
													<EditOutlinedIcon fontSize="small" />
												</IconButton>
											</Tooltip>
											<Tooltip title="Disable">
												<IconButton size="small" onClick={(event) => handleDisable(event, row)}>
													<DeleteOutlinedIcon fontSize="small" />
												</IconButton>
											</Tooltip>
										</TableCell>
									)}
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 50, 100]}
					component="div"
					count={data?.totalCount || 10}
					rowsPerPage={bannerDataLimit}
					page={bannerDataPage}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</>
		</Paper>
	);
};

export default BannerTable;
